


















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import OrderListItem from '@spa/components/pages/order/order/order-list/read-only/OrderListItem.vue'
import { Order } from '@spa/services/order'
import { OrderResult } from '@spa/store/modules/orderConfirm/types'

@Component({
  components: {
    OrderListItem,
  },
})
export default class OrderResultList extends Vue {
  @Prop({ required: true })
  results: OrderResult[]

  @Prop({ required: true })
  canScheduleDelivery: boolean

  genUniqueKey(order: Order): string {
    return order.cartItems.map(i => i.id).join('_')
  }
}
